export class MaintenanceWithTeamviewerPage {

  _downloadTeamViewerLinkEl;
  _teamViewerLinks;
  _teamViewerPlatformDownloadLink;
  _isLinuxPlatform;

  constructor() {
    this._isLinuxPlatform = false;
    this._teamViewerLinks = {
      ios: 'https://apps.apple.com/us/app/teamviewer/id692035811',
      android: 'https://play.google.com/store/apps/details?id=com.teamviewer.teamviewer.market.mobile'
    };
  }

  init() {
    this._downloadTeamViewerLinkEl = document.querySelector('.maintenance-with-teamviewer-page-wrapper .teamviewer-link');

    if (this._downloadTeamViewerLinkEl) {
      this.checkPlatform();
    }
  }

  checkPlatform() {
    const platform = navigator.platform.toLowerCase();

    if (platform.includes('iphone')) {
      this._teamViewerPlatformDownloadLink = this._teamViewerLinks.ios;
      this.setDownloadTeamViewerLinkHref();
    } else if (navigator.userAgent.toLowerCase().includes('android')) {
      this._teamViewerPlatformDownloadLink = this._teamViewerLinks.android;
      this.setDownloadTeamViewerLinkHref();
    }
  }

  setDownloadTeamViewerLinkHref() {
    this._downloadTeamViewerLinkEl.setAttribute('href', this._teamViewerPlatformDownloadLink);
  }
}
